<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-02 14:55:07
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-11-04 14:26:30
-->
<template>
	<div>
		<el-drawer title="重置账号" :visible.sync="drawer" :wrapperClosable="false" @closed="handleClose" ref="drawer" size="724px">
			<Tip class="tip">
				<div slot="content" class="flex-row-align-center">
					<p class="font-h4-regular ml-10 pre yx-color-primary">重置该账号的登录手机号后，请用新的手机号登录后重新绑定微信。</p>
				</div>
			</Tip>
			<div class="account-info mt-16">
				<div class="yx-pingfang-semibold yx-color-text-primary font-h2-regular flex-row-align-center">
					{{ form.nickname }}
					<div class="role-label ml-4 yx-color-primary" v-for="item in roleType" :key="item.id">
						{{ item.name }}
					</div>
				</div>
				<div class="yx-color-text-regular font-h4-regular mt-4">
					原登录手机号：
					<span class="yx-color-text-primary">{{ form.mobile }}</span>
				</div>
			</div>
			<el-form :model="formData" :rules="rules" ref="formData" class="mt-20">
				<el-form-item label="新️登录手机号(必填)" :label-width="formLabelWidth" prop="mobile">
					<el-input v-model="formData.mobile" placeholder="请填写"></el-input>
				</el-form-item>
			</el-form>
			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="save(form)">确认</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { validateTel } from '@/utils/validate';
export default {
	data() {
		return {
			formLabelWidth: '150px',
			drawer: false,
			form: {},
			formData: {
				mobile: '', // 登录手机号
			},
			rules: {
				mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
			},
			roleType: [],
		};
	},

	props: {},
	components: {  },

	mounted() {},

	methods: {
		show(val) {
			this.roleType = val.role;
			this.form = {
				...val,
			};
			this.drawer = true;
		},
		// save: throttle(function(form) {
		// 	this.$refs.formData.validate(valid => {
		// 		if (valid) {
		// 			this.
		// 		}
		// 	});
		// }, 1000),
		handleClose() {
			this.formData = {
				mobile: '',
			};
			this.$refs.formData.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.account-info {
	width: 100%;
	padding: 16px;
	background: #f7f8fa;
	border-radius: 2px;
	box-sizing: border-box;
}
.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: fixed;
	bottom: 0px;
	width: 724px;
	height: 64px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	&/deep/.el-button + .el-button {
		margin-right: 45px !important;
		margin-left: 16px !important;
		width: 88px;
	}
	&/deep/:first-child {
		width: 76px !important;
	}
}
/deep/ .el-drawer__body {
	padding: 0 24px;
}
</style>
